var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCheckoutContext, } from "../../../../context/useCheckoutContext";
import { useKushkiJsContext } from "../../../../context/useKushkiJsContext";
import { configCardSections } from "../../../../shared/constants/CheckoutContants";
import { useEffect } from "react";
import { SavedPaymentKpayEnum } from "../../../../shared/constants/SavedPaymentKpayEnum";
import { PaymentMethodsEnum } from "../../../../shared/constants/PaymentMethodEnum";
export var useCheckoutKpayPaymentSelect = function () {
    var _a = useCheckoutContext(), emailKpay = _a.emailKpay, _b = _a.handlers, setCheckoutSection = _b.setCheckoutSection, setKpaySelected = _b.setKpaySelected, setIsDelete = _b.setIsDelete, setKpayCvvPaymentData = _b.setKpayCvvPaymentData, setPaymentMethodsKpay = _b.setPaymentMethodsKpay, setCheckoutLoading = _b.setCheckoutLoading, paymentMethodsKpay = _a.paymentMethodsKpay;
    var _c = useKushkiJsContext(), deletePaymentMethod = _c.deletePaymentMethod, requestInitAuth = _c.requestInitAuth, requestSavedPaymentMethods = _c.requestSavedPaymentMethods;
    var initKpayPaymentMethods = function () { return __awaiter(void 0, void 0, void 0, function () {
        var paymentMethodKpay, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCheckoutLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestSavedPaymentMethods({
                            email: emailKpay,
                        })];
                case 2:
                    paymentMethodKpay = _a.sent();
                    if (paymentMethodKpay.length > 0) {
                        setPaymentMethodsKpay(paymentMethodKpay);
                    }
                    else
                        setCheckoutSection(configCardSections.kpayEmptyPayment);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    setCheckoutSection(configCardSections.kpayEmptyPayment);
                    return [3 /*break*/, 5];
                case 4:
                    setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (emailKpay) {
            initKpayPaymentMethods();
        }
    }, []);
    var handleInitAuth = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCheckoutLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestInitAuth({ email: emailKpay })];
                case 2:
                    _a.sent();
                    return [2 /*return*/, true];
                case 3:
                    e_2 = _a.sent();
                    if (e_2.code === "K010")
                        setCheckoutSection(configCardSections.kpayOtp);
                    return [2 /*return*/, false];
                case 4:
                    setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var setRedirection = function (method) { return __awaiter(void 0, void 0, void 0, function () {
        var session, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsDelete(false);
                    if (!(method.kind === SavedPaymentKpayEnum.CARD)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleInitAuth()];
                case 2:
                    session = _a.sent();
                    setKpayCvvPaymentData(method);
                    if (session)
                        setCheckoutSection(configCardSections.kpayCvv);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if (error_1.code === "K010")
                        setCheckoutSection(configCardSections.kpayOtp);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    switch (method.kind) {
                        case PaymentMethodsEnum.TRANSFER:
                            setKpaySelected(method);
                            setCheckoutSection(configCardSections.transfer);
                            break;
                        case PaymentMethodsEnum.CASH:
                            setKpaySelected(method);
                            setCheckoutSection(configCardSections.cash);
                            break;
                    }
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handlerDelete = function (paymentMethodKpayId) { return __awaiter(void 0, void 0, void 0, function () {
        var deleteKpayMethod, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deletePaymentMethod({
                            walletId: paymentMethodKpayId,
                        })];
                case 1:
                    deleteKpayMethod = _a.sent();
                    if (deleteKpayMethod) {
                        initKpayPaymentMethods();
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        handlers: {
            handleInitAuth: handleInitAuth,
            handlerDelete: handlerDelete,
            setCheckoutSection: setCheckoutSection,
            setIsDelete: setIsDelete,
            setRedirection: setRedirection,
        },
        paymentMethodsKpay: paymentMethodsKpay,
    };
};
